import env from 'env'

export const updateBusinessDetails = data => ({
  type: 'api/business/UPDATE_BUSINESS_DETAILS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/me/company',
      data,
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
updateBusinessDetails.toString = () => 'api/business/UPDATE_BUSINESS_DETAILS'
